export default function getPriceToCall(actionSummary) {
	const amountsCommitted = [];

	for (let pos in actionSummary) {
		amountsCommitted.push(parseInt(actionSummary[pos].amountCommitted));
	}

	return Math.max(...amountsCommitted);
}
